import React from 'react';
import { Drawer, List, ListItem, ListItemIcon, ListItemText, IconButton } from '@mui/material';
import { 
  FaTimes, 
  FaEnvelope, 
  FaRegSun, 
  FaUserAlt,  
  FaRegFileAlt,
  FaSignOutAlt,
  FaQrcode
} from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import './styles.css';

const Sidebar = ({ active, setActive }) => {

  const navigate = useNavigate();

  const closeSidebar = () => {
    setActive(false);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/Login');
  };

  const menuItems = [
    { Icon: FaEnvelope, Text: "Aguardando envio", to: "/Home" },
    { Icon: FaRegFileAlt, Text: "Enviados", to: "/Enviados" },
    { Icon: FaQrcode, Text: "Leitor Qr", to: "/CameraPage" },
    { Icon: FaUserAlt, Text: "Cliente Cadastro", onClick: () => handleOpenInNewTab('/Cadastro') },
    { Icon: FaRegSun, Text: "Configurações", to: "/Configuracoes" },
    { Icon: FaSignOutAlt, Text: "Sair", onClick: handleLogout }
  ];

  const handleOpenInNewTab = (url) => {
    window.open(url, '_blank');
  };

  return (
    <Drawer
      anchor="left"
      open={active}
      onClose={closeSidebar}
      classes={{ paper: 'sidebar-paper' }}
    >
      <div className="sidebar-header">
        <IconButton onClick={closeSidebar}>
          <FaTimes />
        </IconButton>
      </div>
      <List>
        {menuItems.map((item, index) => (
          <ListItem button key={index} onClick={() => item.to ? navigate(item.to) : item.onClick()}>
            <ListItemIcon>
              <item.Icon />
            </ListItemIcon>
            <ListItemText primary={item.Text} />
          </ListItem>
        ))}
      </List>
    </Drawer>
  );
};

export default Sidebar;